import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_125_purchase_return_voucher: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "126",
      action: "modulev1/purchase_return_voucher_add",
    },
    title: "Purchase Return Vouchers",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "purchase_return_no",
            Name: "purchase_return_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/purchase_return_voucher_add/<id>",
                },
                ActionType: "Edit",
                ScreenId: "126",
                tooltip: "Edit draft",
                visibleForDraftOnly: true,
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "purchase_return_pdf_view",
                },
                ActionType: "PDF_DOWNLOAD",
                ScreenId: "126",
              },
            ],
            Form: {
              Name: "purchase_return_summary",
              TableName: "purchase_return_voucher",
              DisplayName: "purchase_return_summary",
              Query: "SELECT purchase_return.id AS id, purchase_return.vendor_refno, CASE WHEN COALESCE(prd_agg.line_cnt, 0) > 0 THEN prd_agg.line_amount ELSE COALESCE(purchase_return.amount, 0) END AS gross_amount, CASE WHEN COALESCE(prd_agg.line_cnt, 0) > 0 THEN prd_agg.line_vat ELSE COALESCE(purchase_return.vat_amount, 0) END AS vat_amount, CASE WHEN COALESCE(prd_agg.line_cnt, 0) > 0 THEN prd_agg.line_net ELSE COALESCE(purchase_return.net_amount, 0) END AS net_amount, purchase_return.purchase_return_no, P.purchase_no, purchase_return.purchase_retrun_date, users.username AS created_by, COALESCE(supplier_details.suppliername, '') AS suppliername, COALESCE(purchase_return.is_draft, 0) AS is_draft, CASE WHEN COALESCE(purchase_return.is_draft, 0) = 1 THEN 'Draft' ELSE '' END AS draft_status FROM purchase_return LEFT JOIN purchase P ON P.id = purchase_return.purchase_id LEFT JOIN purchase_order POR ON POR.id = P.purchase_order_id LEFT JOIN supplier_details ON supplier_details.id = COALESCE(P.supplier_id, POR.supplier_id) LEFT JOIN users ON users.id = purchase_return.created_by LEFT JOIN LATERAL ( SELECT COALESCE(SUM(CASE WHEN COALESCE(prd.qty, 0) > 0 THEN COALESCE(prd.amount, 0) ELSE 0 END), 0) AS line_amount, COALESCE(SUM(CASE WHEN COALESCE(prd.qty, 0) > 0 THEN COALESCE(prd.vat_amt, 0) ELSE 0 END), 0) AS line_vat, COALESCE(SUM(CASE WHEN COALESCE(prd.qty, 0) > 0 THEN COALESCE(prd.net_amt, 0) ELSE 0 END), 0) AS line_net, COUNT(CASE WHEN COALESCE(prd.qty, 0) > 0 THEN 1 END) AS line_cnt FROM purchase_return_details prd WHERE prd.parent_id = purchase_return.id AND COALESCE(prd.soft_delete, 0) = 0 ) prd_agg ON true WHERE purchase_return.soft_delete = 0 ORDER BY purchase_return.purchase_retrun_date DESC, purchase_return.purchase_return_no DESC",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "txt_id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Return date",
                  IsMandatory: false,
                  BindValue: "txt_returndate",
                  Json_Attribute: "purchase_retrun_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Return No.",
                  BindValue: "txt_pr_ord_no",
                  Json_Attribute: "purchase_return_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Draft",
                  BindValue: "txt_draft_status",
                  Json_Attribute: "draft_status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "is_draft",
                  BindValue: "txt_is_draft",
                  Json_Attribute: "is_draft",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Purchase No.",
                  BindValue: "txt_prno",
                  Json_Attribute: "purchase_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Ref No.",
                  BindValue: "txt_Refno",
                  Json_Attribute: "vendor_refno",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsClear: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor name",
                  BindValue: "name",
                  Json_Attribute: "suppliername",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Gross amount",
                  BindValue: "txt_gross_amt",
                  Json_Attribute: "gross_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsClear: false,
                },
                {
                  IncludeLabel: true,
                  Label: "VAT amount",
                  BindValue: "txt_vat_amt",
                  Json_Attribute: "vat_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsClear: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Net amount",
                  BindValue: "txt_net_amt",
                  Json_Attribute: "net_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsClear: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "created_by",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsClear: false,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
